﻿(function () {
  // =======================
  // CONFIG
  // =======================
  const DEFAULT_PHONE = "";
  const SGTM_BASE = "";
  const SGTM_WA_CLICK_PATH = "";
  const ATTR_KEY = "";
  const ATTR_STORAGE_KEY = ATTR_KEY || "dj_attr";

  // Odoo timestamp-Ñ„Ð¾Ð»Ð±ÑÐº: Ð´ÑƒÐ±Ð»Ð¸Ñ€ÑƒÐµÐ¼ Ñ‚Ð¾ÐºÐµÐ½ ÐºÐ»Ð¸ÐºÐ° Ð½Ð°Ð¿Ñ€ÑÐ¼ÑƒÑŽ Ð² Odoo Ð½Ð° ÑÐ»ÑƒÑ‡Ð°Ð¹,
  // ÐµÑÐ»Ð¸ Ð¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ñ‚ÐµÐ»ÑŒ ÑƒÐ´Ð°Ð»Ð¸Ñ‚ URL/Ñ‚Ð¾ÐºÐµÐ½ Ð¸Ð· Ñ‚ÐµÐºÑÑ‚Ð° WhatsApp-ÑÐ¾Ð¾Ð±Ñ‰ÐµÐ½Ð¸Ñ.
  const ODOO_CLICK_URL = "";
  const ODOO_CLICK_SECRET = "";

  // =======================
  // HELPERS
  // =======================
  function qs(name) {
    try { return new URLSearchParams(location.search).get(name) || ""; }
    catch { return ""; }
  }

  function readAttr() {
    try { return JSON.parse(localStorage.getItem(ATTR_STORAGE_KEY) || "{}"); }
    catch { return {}; }
  }

  function writeAttr(obj) {
    try { localStorage.setItem(ATTR_STORAGE_KEY, JSON.stringify(obj)); } catch {}
  }

  function nowIso() {
    try { return new Date().toISOString(); } catch { return ""; }
  }

  // ÐžÑ‡Ð¸Ñ‰Ð°ÐµÑ‚ URL Ð¾Ñ‚ tracking-Ð¿Ð°Ñ€Ð°Ð¼ÐµÑ‚Ñ€Ð¾Ð², Ð¾ÑÑ‚Ð°Ð²Ð»ÑÐµÑ‚ variant Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ‚ ref=token
  function cleanMessageUrl(rawUrl, token) {
    try {
      const u = new URL(String(rawUrl || ""), location.origin);
      const keepVariant = u.searchParams.get("variant");
      u.search = "";
      if (keepVariant) u.searchParams.set("variant", keepVariant);
      if (token) u.searchParams.set("ref", token);
      u.hash = "";
      return u.toString();
    } catch {
      const s = String(rawUrl || "");
      const base = s.split("?")[0].split("#")[0];
      return token ? base + "?ref=" + token : base;
    }
  }

  function detectSourcePrefix(attr) {
    attr = (attr && typeof attr === "object") ? attr : {};
    const src = String(attr.utm_source || "").toLowerCase();
    const med = String(attr.utm_medium || "").toLowerCase();

    const hasGoogleClickId = !!(attr.gclid || attr.gbraid || attr.wbraid);
    const hasMetaClickId = !!attr.fbclid;

    // Paid click-ids take priority
    if (hasGoogleClickId) return "GA";
    if (hasMetaClickId) return "FB";

    // Paid medium fallback (sometimes click IDs are stripped)
    if (med.includes("cpc") || med.includes("ppc") || med.includes("paid")) {
      if (src.includes("google")) return "GA";
      if (src.includes("facebook") || src.includes("instagram") || src === "fb" || src === "ig") return "FB";
    }

    // Organic source classification
    if (src.includes("google")) return "OG";
    if (src.includes("facebook") || src.includes("instagram") || src === "fb" || src === "ig") return "OM";

    return "OO";
  }

  function genTokenWithPrefix(prefix) {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // avoids 0/O/I/1 confusion
    let rand = "";
    for (let i = 0; i < 6; i++) rand += chars[Math.floor(Math.random() * chars.length)];
    return "dj_" + String(prefix || "OO") + rand;
  }

  function captureAttr() {
    const prev = readAttr();

    // Detect if a NEW click-id arrived in the current URL (new ad click)
    const incoming = {
      gclid:  qs("gclid")  || "",
      gbraid: qs("gbraid") || "",
      wbraid: qs("wbraid") || "",
      fbclid: qs("fbclid") || ""
    };

    const hasIncomingClickId = !!(incoming.gclid || incoming.gbraid || incoming.wbraid || incoming.fbclid);

    const incomingChanged =
      (incoming.gclid  && incoming.gclid  !== (prev.gclid  || "")) ||
      (incoming.gbraid && incoming.gbraid !== (prev.gbraid || "")) ||
      (incoming.wbraid && incoming.wbraid !== (prev.wbraid || "")) ||
      (incoming.fbclid && incoming.fbclid !== (prev.fbclid || ""));

    const attr = {
      utm_source:   qs("utm_source")   || prev.utm_source   || "",
      utm_medium:   qs("utm_medium")   || prev.utm_medium   || "",
      utm_campaign: qs("utm_campaign") || prev.utm_campaign || "",
      utm_content:  qs("utm_content")  || prev.utm_content  || "",
      utm_term:     qs("utm_term")     || prev.utm_term     || "",

      // Click IDs (priority: current URL > previously stored)
      gclid:  incoming.gclid  || prev.gclid  || "",
      gbraid: incoming.gbraid || prev.gbraid || "",
      wbraid: incoming.wbraid || prev.wbraid || "",
      fbclid: incoming.fbclid || prev.fbclid || "",

      first_landing: prev.first_landing || location.href,
      last_seen: location.href,
      captured_at: prev.captured_at || nowIso()
    };

    // Token rules:
    // - Keep same token for the same attribution
    // - If a new click-id is detected (new paid click), rotate token
    const prefix = detectSourcePrefix(attr);
    const prevPrefix = prev.token_prefix || "";
    const shouldRotateToken = (hasIncomingClickId && incomingChanged) || (prevPrefix && prevPrefix !== prefix);

    if (prev.token && !shouldRotateToken) {
      attr.token = prev.token;
      attr.token_prefix = prevPrefix || prefix;
      attr.token_created_at = prev.token_created_at || attr.captured_at || nowIso();
    } else {
      attr.token = genTokenWithPrefix(prefix);
      attr.token_prefix = prefix;
      attr.token_created_at = nowIso();
    }

    writeAttr(attr);
    return attr;
  }

  /**
   * IMPORTANT for reliability:
   * When you redirect to WhatsApp right after click, normal fetch can be cancelled.
   * sendBeacon (or fetch keepalive) makes the POST much more reliable.
   */
  function postToSgtm(payload) {
    if (!SGTM_BASE || !SGTM_WA_CLICK_PATH) return false;
    try {
      const url = SGTM_BASE.replace(/\/+$/, "") + SGTM_WA_CLICK_PATH;
      const body = JSON.stringify(payload);

      // 1) Best effort: sendBeacon
      if (navigator && typeof navigator.sendBeacon === "function") {
        try {
          const ok = navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
          if (ok) {
            console.log("WA CLICK SENT (beacon):", payload);
            return true;
          }
        } catch (e) {
          // fall back to fetch
        }
      }

      // 2) Fallback: fetch (keepalive so it can continue during navigation)
      fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body,
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      })
        .then(() => console.log("WA CLICK SENT (fetch):", payload))
        .catch((err) => console.error("WA CLICK ERROR:", err));

      return true;
    } catch {
      return false;
    }
  }

  /**
   * Ð”ÑƒÐ±Ð»Ð¸Ñ€ÑƒÐµÑ‚ ÑÐ¾Ð±Ñ‹Ñ‚Ð¸Ðµ ÐºÐ»Ð¸ÐºÐ° Ð½Ð°Ð¿Ñ€ÑÐ¼ÑƒÑŽ Ð² Odoo (timestamp-Ñ„Ð¾Ð»Ð±ÑÐº Ð°Ñ‚Ñ€Ð¸Ð±ÑƒÑ†Ð¸Ð¸).
   * ÐÐ´Ð´Ð¸Ñ‚Ð¸Ð²Ð½Ð¾ Ðº postToSgtm: ÐµÑÐ»Ð¸ Ð¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ñ‚ÐµÐ»ÑŒ ÑƒÐ´Ð°Ð»Ð¸Ñ‚ URL/Ñ‚Ð¾ÐºÐµÐ½ Ð¸Ð· Ñ‚ÐµÐºÑÑ‚Ð°
   * ÑÐ¾Ð¾Ð±Ñ‰ÐµÐ½Ð¸Ñ, Odoo ÑÐ¼Ð°Ñ‚Ñ‡Ð¸Ñ‚ ÑÑ‚Ð¾Ñ‚ ÐºÐ»Ð¸Ðº Ñ Ð²Ñ…Ð¾Ð´ÑÑ‰Ð¸Ð¼ ÑÐ¾Ð¾Ð±Ñ‰ÐµÐ½Ð¸ÐµÐ¼ Ð¿Ð¾ Ð²Ñ€ÐµÐ¼ÐµÐ½Ð¸.
   * Ð˜ÑÐ¿Ð¾Ð»ÑŒÐ·ÑƒÐµÐ¼ text/plain Blob â€” ÑÑ‚Ð¾ "Ð¿Ñ€Ð¾ÑÑ‚Ð¾Ð¹" Ð·Ð°Ð¿Ñ€Ð¾Ñ, Ð±ÐµÐ· CORS-preflight.
   * ÐŸÐ¾Ð»Ð½Ð¾ÑÑ‚ÑŒÑŽ Ð¸Ð·Ð¾Ð»Ð¸Ñ€Ð¾Ð²Ð°Ð½Ð¾ Ð² try/catch Ð¸ Ð½Ðµ Ð²Ð»Ð¸ÑÐµÑ‚ Ð½Ð° Ñ€ÐµÐ´Ð¸Ñ€ÐµÐºÑ‚ Ð² WhatsApp.
   */
  function postToOdooClick(token, dest, url) {
    if (!ODOO_CLICK_URL || !ODOO_CLICK_SECRET) return false;
    try {
      if (!token) return false;
      const body = JSON.stringify({
        token: token,
        ts: Date.now(),
        dest: String(dest || "").replace(/[^\d]/g, ""),
        url: url || location.href,
        secret: ODOO_CLICK_SECRET
      });

      // 1) sendBeacon â€” Ð½Ð°Ð´Ñ‘Ð¶Ð½Ð¾ Ð¿Ñ€Ð¸ Ð½ÐµÐ¼ÐµÐ´Ð»ÐµÐ½Ð½Ð¾Ð¹ Ð½Ð°Ð²Ð¸Ð³Ð°Ñ†Ð¸Ð¸ Ð½Ð° WhatsApp.
      if (navigator && typeof navigator.sendBeacon === "function") {
        try {
          const ok = navigator.sendBeacon(ODOO_CLICK_URL, new Blob([body], { type: "text/plain" }));
          if (ok) {
            console.log("WA CLICK -> ODOO (beacon):", token);
            return true;
          }
        } catch (e) {
          // Ð¿ÐµÑ€ÐµÑ…Ð¾Ð´Ð¸Ð¼ Ð½Ð° fetch
        }
      }

      // 2) Fallback: fetch keepalive (text/plain => Ð±ÐµÐ· preflight).
      fetch(ODOO_CLICK_URL, {
        method: "POST",
        headers: { "content-type": "text/plain" },
        body: body,
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      })
        .then(() => console.log("WA CLICK -> ODOO (fetch):", token))
        .catch(function () {});

      return true;
    } catch {
      return false;
    }
  }

  function isWhatsAppHref(href) {
    if (!href) return false;
    return (
      href.includes("api.whatsapp.com/send") ||
      href.includes("wa.me/") ||
      href.includes("whatsapp://send")
    );
  }

  function normalizePhoneFromHref(href) {
    try {
      if (href.startsWith("whatsapp://")) return DEFAULT_PHONE;

      const u = new URL(href, location.origin);

      // wa.me/<number>
      if (u.hostname === "wa.me") {
        const p = (u.pathname || "").replace(/\//g, "");
        return (p || DEFAULT_PHONE).replace(/[^\d]/g, "");
      }

      // api.whatsapp.com/send/?phone=...
      const phone = u.searchParams.get("phone");
      return (phone || DEFAULT_PHONE).replace(/[^\d]/g, "");
    } catch {
      return DEFAULT_PHONE.replace(/[^\d]/g, "");
    }
  }

  function getExistingTextFromHref(href) {
    try {
      if (href.startsWith("whatsapp://")) {
        const u = new URL(href);
        const t = u.searchParams.get("text") || "";
        return decodeURIComponent(t.replace(/\+/g, " "));
      }

      const u = new URL(href, location.origin);
      const t = u.searchParams.get("text") || "";
      return t ? decodeURIComponent(t.replace(/\+/g, " ")) : "";
    } catch {
      return "";
    }
  }

  function openWhatsApp(phone, message) {
    const cleanPhone = (phone || DEFAULT_PHONE).replace(/[^\d]/g, "");
    const url =
      `https://api.whatsapp.com/send/?phone=${encodeURIComponent(cleanPhone)}` +
      `&text=${encodeURIComponent(message)}` +
      `&type=phone_number&app_absent=0`;
    window.location.assign(url);
  }

  // =======================
  // MAIN HANDLER (single source of truth)
  // =======================
  // DJ Google Ads WhatsApp secondary conversion
  // Secondary only: it is observed for reporting and never used as a bidding goal.
  function sendGoogleAdsWhatsAppConversion() {
    try {
      if (typeof window.gtag !== "function") return false;
      window.gtag("event", "conversion", { "send_to": "AW-10871674403/cKfWCL76w_YcEKOsgsAo" });
      return true;
    } catch (_) {
      return false;
    }
  }

  function runWhatsAppFlow(context) {
    sendGoogleAdsWhatsAppConversion();
    const attr = captureAttr();
    const token = attr.token || genTokenWithPrefix(detectSourcePrefix(attr));

    // Send to sGTM/Stape (store token->attribution)
    postToSgtm({
      event: "dj_wa_click",
      token,
      page_url: location.href,
      first_landing: attr.first_landing || "",
      captured_at: attr.captured_at || "",
      clicked_at: nowIso(),
      utm_source: attr.utm_source || "",
      utm_medium: attr.utm_medium || "",
      utm_campaign: attr.utm_campaign || "",
      utm_content: attr.utm_content || "",
      utm_term: attr.utm_term || "",
      gclid: attr.gclid || "",
      gbraid: attr.gbraid || "",
      wbraid: attr.wbraid || "",
      fbclid: attr.fbclid || "",
      context: context || {}
    });

    // Ð”ÑƒÐ±Ð»ÑŒ ÐºÐ»Ð¸ÐºÐ° Ð½Ð°Ð¿Ñ€ÑÐ¼ÑƒÑŽ Ð² Odoo (timestamp-Ñ„Ð¾Ð»Ð±ÑÐº, Ð½Ðµ Ð±Ð»Ð¾ÐºÐ¸Ñ€ÑƒÐµÑ‚ Ñ€ÐµÐ´Ð¸Ñ€ÐµÐºÑ‚)
    postToOdooClick(
      token,
      context && context.phone ? context.phone : DEFAULT_PHONE,
      context && context.url ? context.url : location.href
    );

    // Build WhatsApp message
    const existing = (context && context.existing_text) ? context.existing_text.trim() : "";
    const lines = [];

    if (existing) lines.push(existing);
    else lines.push((window.fpTexts && window.fpTexts.waProductMoreDetails) || "Hi! I'd like to get more details:");

    if (context && context.url) lines.push(cleanMessageUrl(context.url, token));
    lines.push("");

    openWhatsApp(context && context.phone ? context.phone : DEFAULT_PHONE, lines.join("\n"));
  }

  // =======================
  // SINGLE, FAST EVENT-DELEGATED CLICK HANDLER
  // (no MutationObserver / polling => removes any chance of page slowdown)
  // =======================
  document.addEventListener("click", function (e) {
    const t = e.target && e.target.closest ? e.target.closest.bind(e.target) : null;
    if (!t) return;

    const closePanel = e.target.closest(".dj-wa-floating__close");
    if (closePanel) { e.preventDefault(); closePanel.closest(".dj-wa-floating")?.classList.add("is-panel-closed"); return; }

    // 1) Floating widget
    const fw = e.target.closest("#whatsapp-floating-widget");
    if (fw) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      runWhatsAppFlow({
        type: "floating_widget",
        phone: normalizePhoneFromHref(fw.getAttribute("href") || ""),
        existing_text: fw.getAttribute("data-wa-message") || "Hi! I'd like to get more details:",
        url: fw.getAttribute("data-wa-url") || location.href
      });
      return;
    }

    // 2) Product button (if theme/app uses this id)
    const pb = e.target.closest("#whatsapp-order-button");
    if (pb) {
      const outOfStock = pb.getAttribute("data-out-of-stock") === "true";
      const variantOut = pb.getAttribute("data-variant-out-of-stock") === "true";
      if (outOfStock || variantOut) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      const variantId = pb.getAttribute("data-current-variant-id") || "";
      let productUrl = pb.getAttribute("data-wa-url") || location.href;
      if (variantId) {
        try {
          const u = new URL(productUrl, location.origin);
          if (!u.searchParams.get("variant")) u.searchParams.set("variant", String(variantId));
          productUrl = u.toString();
        } catch {}
      }
      runWhatsAppFlow({
        type: "product_button",
        phone: normalizePhoneFromHref(pb.getAttribute("href") || ""),
        existing_text: pb.getAttribute("data-wa-message") || "Hi! I'd like to get more details:",
        url: productUrl
      });
      return;
    }

    // 3) Any WhatsApp <a href> (CA app or theme)
    const a = e.target.closest("a[href]");
    if (!a) return;

    if (a.dataset.fpHandled === "1") return;

    const href = a.getAttribute("href") || "";
    if (!isWhatsAppHref(href)) return;

    a.dataset.fpHandled = "1";

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    runWhatsAppFlow({
      type: "generic_whatsapp_link",
      phone: normalizePhoneFromHref(href),
      existing_text: getExistingTextFromHref(href),
      url: location.href
    });
  }, true);

  // =======================
  // INIT (lightweight)
  // =======================
  try { captureAttr(); } catch (e) { console.warn("[FP WA Attribution] captureAttr failed", e); }

})();

